module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/our_clients_img1.e54e997a.png";